import React from "react";
import {
  Home,
  About,
  Contact,
  Footer,
  Navbar,
  Projects,
  Sports,
  Gaming,
  Movies,
  Project1,
  Project2,
  Project3,
  Project4,
  // Project5,
  NotFound,
} from "./components/index";
import styled, { ThemeProvider } from "styled-components";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import gridSvg from "./images/grid.svg";
import { GlobalStyle } from "./GlobalStyles";

const App = () => {
  const moveLight = (e) => {
    const light = document.querySelector(".light");
    const scrollY = document.documentElement.scrollTop;
    light.style.left = `${e.clientX}px`;
    light.style.top = `${e.clientY + scrollY}px`;
  };

  const theme = {
    dark: {
      primary: "#000",
      text: "#fff",
      neutral: "#9a9a9a",
      secondary: "blue",
      custom: "#23cbf5",
      navBackground: "rgba(0, 0, 0, 0.8)",
    },
    light: {
      primary: "#fff",
      text: "#000",
      neutral: "#9a9a9a",
      secondary: "blue",
      custom: "#23cbf5",
      navBackground: "rgba(255, 255, 255, 0.8)",
    },
  };

  const location = useLocation();

  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <Main onMouseOver={moveLight}>
          <div className="hex-grid">
            <div className="light"></div>
            <div className="grid"></div>
          </div>
          <Navbar />
          <AnimatePresence exitBeforeEnter>
            <Routes location={location} key={location.pathname}>
              <Route exact path="/" element={<Home />} />
              <Route path="about" element={<About />}>
                <Route index element={<Gaming />} />
                <Route path="gaming" element={<Gaming />} />
                <Route path="Music" element={<Movies />} />
                <Route path="sports" element={<Sports />} />
              </Route>
              <Route path="projects" element={<Projects />} />
              <Route path="contact" element={<Contact />} />
              <Route path="project1" element={<Project1 />} />
              <Route path="project2" element={<Project2 />} />
              <Route path="project3" element={<Project3 />} />
              <Route path="project4" element={<Project4 />} />
              {/* <Route path="project5" element={<Project5 />} /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AnimatePresence>
          <Footer />
        </Main>
      </ThemeProvider>
    </>
  );
};

export default App;

const Main = styled.main`
  overflow-y: hidden;
  overflow-x: hidden;
  padding: 0 0 0 4rem;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  color: ${(props) => props.theme.dark.text};
  background-color: ${(props) => props.theme.dark.primary};
  min-height: 100vh;
  position: relative;

  .hex-grid .grid {
    position: absolute;
    top: 0;
    left: 0;
    background: url(${gridSvg}) repeat;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-size: 500px;
  }

  .hex-grid .light {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 15em;
    height: 15em;
    filter: blur(15px);
    background: linear-gradient(90deg, #c8f4ff 0%, #23cbf5 100%);
    z-index: 0;
  }

  a {
    color: ${(props) => props.theme.dark.text};
  }

  @media screen and (max-width: 760px) {
    padding: 0;
    padding: 0 1rem;
  }

  /*  @media (prefers-color-scheme: light) {
    color: ${(props) => props.theme.light.text};
    background-color: ${(props) => props.theme.light.primary};

    a {
      color: ${(props) => props.theme.light.text};
    }
  } */
`;
